import { getPermitIcon } from "../icons";
import Position from "../types/Position";
import WorkPermit from "../types/WorkPermit";
import L from "leaflet";
import { CodeStatus, PermitCategory, PermitType, ShapeType, WorkPermitTagType } from "./enums";

export function getMarkerZIndex(permit: { status: CodeStatus }, position: { isActive: boolean }): number {
    if (position.isActive && permit.status === CodeStatus.Accepted) {
        return 400;
    }

    switch (permit.status) {
        case CodeStatus.Rejected:
            return 0;
        case CodeStatus.Archived:
            return 100;
        case CodeStatus.Registered:
            return 200;
        case CodeStatus.Accepted:
            return 300;
    }

    return 0;
}
